import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Search } from "lucide-react";
import { toast } from "sonner";

const STATUS_VARIANT = { paid: "default", pending: "secondary", refunded: "outline" };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const refund = async (oid) => {
    if (!window.confirm("Mark this order refunded? The buyer loses library access and gets a refund email. Refund the money itself in your Stripe or PayPal dashboard.")) return;
    try { await api.post(`/admin/orders/${oid}/refund`); toast.success("Refund processed"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Refund failed"); }
  };

  const filtered = orders.filter((o) => !filter ||
    o.buyer_email?.toLowerCase().includes(filter.toLowerCase()) ||
    o.id.toLowerCase().includes(filter.toLowerCase()));

  return (
    <div data-testid="admin-orders">
      <div className="flex items-end justify-between border-b border-border pb-4 mb-6">
        <div>
          <h1 className="font-display text-4xl tracking-tight">Orders</h1>
          <p className="text-sm text-muted-foreground italic mt-1">{orders.length} order{orders.length === 1 ? "" : "s"} on record.</p>
        </div>
        <div className="flex items-center gap-2 bg-muted/60 rounded-sm px-3 py-1.5 border border-border w-72">
          <Search className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />
          <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Search by email or order ID…" className="flex-1 bg-transparent outline-none text-sm" data-testid="orders-search" />
        </div>
      </div>

      <div className="border border-border rounded-sm bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase tracking-[0.18em] text-muted-foreground border-b border-border">
            <tr><th className="px-4 py-3">Order</th><th>Buyer</th><th>Items</th><th>Total</th><th>Status</th><th>Date</th><th></th></tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-sm text-muted-foreground italic">No orders match.</td></tr>}
            {filtered.map((o) => (
              <tr key={o.id} className="border-b border-border last:border-0" data-testid={`adm-order-${o.id}`}>
                <td className="px-4 py-3 font-mono text-xs">{o.id.slice(0, 14)}…</td>
                <td>
                  <div className="text-sm">{o.buyer_name}</div>
                  <div className="text-xs text-muted-foreground">{o.buyer_email}</div>
                </td>
                <td>{o.items.length}</td>
                <td>{o.currency === "usd" ? "US$" : "A$"}{o.total.toFixed(2)}</td>
                <td><Badge variant={STATUS_VARIANT[o.status] || "outline"} className="rounded-sm font-normal capitalize">{o.status}</Badge></td>
                <td className="text-xs text-muted-foreground">{o.created_at?.slice(0, 10)}</td>
                <td className="text-right pr-4">
                  {o.status === "paid" && <Button variant="ghost" size="sm" onClick={() => refund(o.id)} data-testid={`adm-refund-${o.id}`}>Refund</Button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
